<template>
    <div>
        <div class="footer">
            <div class="footer-top">
                <ul>
                    <li>
                        <div class="father">
                            <p @click="toggle">产品与服务</p>
                            <div :class="isopen?'child openChild':'child'">
                                <p v-for="(item,index) in children" :key="index" @click="goBusiness(item.link)">{{item.name}}</p>
                            </div>
                        </div>
                        <b @click="toggle" style="font-size:.4rem; height:.82rem">
                            {{isopen?'-':'+'}}
                        </b>
                    </li>

                    <li @click="openTsa('phoneUs')">
                        <span>关于我们</span>
                        <b>
                            <van-icon name="arrow" color="#CBCBCB" />
                        </b>
                    </li>
                    <li @click="openTsa('about')">
                        <span>联系我们</span>
                        <b>
                            <van-icon name="arrow" color="#CBCBCB" />
                        </b>
                    </li>
                </ul>
            </div>
            <div class="footer-cnt">
                <div class="customer">
                    <div class="qrcode">
                        <dl>
                            <dt>
                                <img
                                    src="https://evidence-public.oss-cn-beijing.aliyuncs.com/customerImages/3.png"
                                    alt="客服微信"
                                />
                            </dt>
                            <dd>客服微信</dd>
                        </dl>
                    </div>
                    <div class="tel">
                        <div class="contract">
                            <img src="../assets/img/home/tel.png" alt="" />
                            <span>400-0186-091</span>
                        </div>
                        <div class="workTime">（工作日：9:00-18:00）</div>
                        <p>微信公众号：时间戳</p>
                    </div>
                </div>
            </div>

            <div class="friendLink">
                <ul class="link-tab">
                    <li :class="item.show?'active':''" v-for="item in friendsLinkList" :key="item.tabTitle" @click="changeLinkTab(item)">{{item.tabTitle}}</li>
                </ul>
                <div class="link-content">
                    <div :class="item.show?'friendship active':'friendship'" v-for="item in friendsLinkList" :key="item.title">
                        <p v-for="linkItem in item.linkList" :key="linkItem.title">
                            <a :href="linkItem.url" target="_blank">{{ linkItem.title }}</a>
                        </p>
                    </div>
                </div>
            </div>
            

            <div class="copyright" style="line-height: 25px">
                版权所有：北京联合信任技术服务有限公司
                <br />
                <a
                    href="https://beian.miit.gov.cn/#/Integrated/index"
                    style="margin-left: 6px"
                    >京ICP备13046264号-2</a
                >
                &nbsp;&nbsp;
                <a
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045493"
                    style="margin-left: 6px"
                    >京公网安备11010502045493号</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            children: [
                {
                    link: process.env.VUE_APP_EV,
                    name: "电子取证",
                },
                {
                    link: process.env.VUE_APP_TSA+"/qlwsDownload",
                    name: "权利卫士",
                },
                {
                    link: process.env.VUE_APP_COPYRIGHT,
                    name: "知识产权保护",
                },
                {
                    link: process.env.VUE_APP_EMAIL,
                    name: "邮件认证",
                },
                {
                    link: process.env.VUE_APP_SIGN,
                    name: "电子签名",
                },
                {
                    link: process.env.VUE_APP_VERIFY,
                    name: "验证中心",
                },
            ],
            friendsLinkList:[
                {
                    show: true,
                    tabTitle:'友情链接',
                    linkList:[
                        {
                            title:'国家授时中心',
                            url:'http://www.ntsc.ac.cn/?LMCL=HcSri1'
                        },
                        {
                            title:'北斗卫星导航',
                            url:'http://www.beidou.gov.cn/'
                        },
                        {
                            title:'北大法宝',
                            url:'https://www.pkulaw.com/'
                        },
                        {
                            title:'联合信任时间戳',
                            url:'https://www.tsa.cn'
                        },
                        {
                            title:'邮件认证平台',
                            url:'https://mail.tsa.cn'
                        },
                        {
                            title:'电子证据平台',
                            url:'https://ev.tsa.cn'
                        },
                        {
                            title:'软著保护平台',
                            url:'https://scp.tsa.cn'
                        },
                        {
                            title:'媒体版权固证平台',
                            url:'http://media.tsa.cn'
                        },
                        {
                            title:'时间戳验证平台',
                            url:'https://v.tsa.cn'
                        },
                        {
                            title:'联合信任时间戳移动端',
                            url:'https://m.tsa.cn'
                        },
                        {
                            title:'知识产权保护平台',
                            url:'https://ipr.tsa.cn'
                        },
                        {
                            title:'联合信任经销商',
                            url:'https://bd.tsa.cn'
                        },
                        {
                            title:'电子签名移动平台',
                            url:'http://1sign-m.tsa.cn'
                        },
                        {
                            title:'时间戳平台登录中心',
                            url:'https://usercenter.tsa.cn'
                        },
                        {
                            title:'电子取证知识',
                            url:'https://www.tsa.cn/baike-dianziquzheng.html'
                        },
                        {
                            title:'电子证据知识',
                            url:'https://www.tsa.cn/baike-dianzizhengju.html'
                        },
                        {
                            title:'知识产权保护知识',
                            url:'https://www.tsa.cn/baike-zhishichanquanbaohu.html'
                        },
                        {
                            title:'邮件认证知识',
                            url:'https://www.tsa.cn/baike-youjianrenzheng.html'
                        },
                        {
                            title:'电子合同认证知识',
                            url:'https://www.tsa.cn/baike-dianzihetong.html'
                        },
                        {
                            title:'侵权取证知识',
                            url:'https://www.tsa.cn/baike-qinquanquzheng.html'
                        },
                        {
                            title:'版权保护知识',
                            url:'https://www.tsa.cn/baike-banquanbaohu.html'
                        },
                        {
                            title:'著作权保护知识',
                            url:'https://www.tsa.cn/baike-zhuzuoquanbaohu.html'
                        },
                        {
                            title:'手机取证知识',
                            url:'https://www.tsa.cn/baike-shoujiquzheng.html'
                        },
                        {
                            title:'违法取证',
                            url:'https://www.tsa.cn/baike-weifaquzheng.html'
                        }
                    ]
                },
                {
                    show: false,
                    tabTitle:'精选服务',
                    linkList:[
                        {
                            title:'联合信任时间戳',
                            url:'https://www.tsa.cn'
                        },
                        {
                            title:'邮件认证平台',
                            url:'https://mail.tsa.cn'
                        },
                        {
                            title:'电子证据平台',
                            url:'https://ev.tsa.cn'
                        },
                        {
                            title:'软著保护平台',
                            url:'https://scp.tsa.cn'
                        },
                        {
                            title:'媒体版权固证平台',
                            url:'http://media.tsa.cn'
                        },
                        {
                            title:'时间戳验证平台',
                            url:'https://v.tsa.cn'
                        },
                        {
                            title:'联合信任时间戳移动端',
                            url:'https://m.tsa.cn'
                        },
                        {
                            title:'知识产权保护平台',
                            url:'https://ipr.tsa.cn'
                        },
                        {
                            title:'联合信任经销商',
                            url:'https://bd.tsa.cn'
                        },
                        {
                            title:'电子签名移动平台',
                            url:'http://1sign-m.tsa.cn'
                        },
                        {
                            title:'时间戳平台登录中心',
                            url:'https://usercenter.tsa.cn'
                        },
                    ]
                },
                {
                    show: false,
                    tabTitle:'最新知识',
                    linkList:[
                        {
                            title:'电子取证知识',
                            url:'https://www.tsa.cn/baike-dianziquzheng.html'
                        },
                        {
                            title:'电子证据知识',
                            url:'https://www.tsa.cn/baike-dianzizhengju.html'
                        },
                        {
                            title:'知识产权保护知识',
                            url:'https://www.tsa.cn/baike-zhishichanquanbaohu.html'
                        },
                        {
                            title:'邮件认证知识',
                            url:'https://www.tsa.cn/baike-youjianrenzheng.html'
                        },
                        {
                            title:'电子合同认证知识',
                            url:'https://www.tsa.cn/baike-dianzihetong.html'
                        },
                        {
                            title:'侵权取证知识',
                            url:'https://www.tsa.cn/baike-qinquanquzheng.html'
                        },
                        {
                            title:'版权保护知识',
                            url:'https://www.tsa.cn/baike-banquanbaohu.html'
                        },
                        {
                            title:'著作权保护知识',
                            url:'https://www.tsa.cn/baike-zhuzuoquanbaohu.html'
                        },
                        {
                            title:'手机取证知识',
                            url:'https://www.tsa.cn/baike-shoujiquzheng.html'
                        },
                        {
                            title:'违法取证',
                            url:'https://www.tsa.cn/baike-weifaquzheng.html'
                        }
                    ]
                }
            ],
            isopen: false,
            activeNames: 1,
        };
    },
    methods: {
        toggle() {
            this.isopen = !this.isopen;
        },
        goBusiness(url){
            window.open(url);
        },
        openTsa(name){
            switch (name) {
                case 'about':
                    window.open(process.env.VUE_APP_TSA+'/about');
                    break;
                case 'phoneUs':
                    window.open(process.env.VUE_APP_TSA+'/phoneUs');
                    break;
            }
        },
        goNext(type) {
            //   type === 1
            //     ? window.open(this.soboten.http)
            //     : type === 2
            //     ? window.open(process.env.VUE_APP_QLW)
            //     : "";
        },
        changeLinkTab(item){
            this.friendsLinkList.map(item => {
                item.show = false
            })
            item.show = true
            this.$forceUpdate();
        },
    },
};
</script>

<style scoped lang="less">
.footer {
    margin: 0 auto;
    box-sizing: border-box;
    background: #323232;
    padding: 0 15px 15px;
    .footer-top {
        margin-bottom: 17px;
        ul {
            li {
                line-height: 42px;
                color: #cbcbcb;
                font-size: 13px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                border-bottom: 1Px solid #e5e5e5;
                b {
                    font-size: 13px;
                    color: #cbcbcb;
                }
                .father{
                    width: 100%;
                    .child{
                        transition: all 0.6s;
                        height:0;
                        overflow: hidden;
                        padding-left: 25px;
                        p{
                            line-height: 20px;
                            margin-bottom: 15px;
                        }
                    }
                    .openChild{
                        transition: all 0.6s;
                        height:210px;
                    }
                }
                
            }
        }
    }
    .footer-cnt {
        padding-top: 33px;
        .customer {
            display: flex;
            flex-direction: row;
            .qrcode {
                border-right: 1Px solid #cbcbcb;
                flex: 3;
                text-align: center;
                padding-top: 7px;
                dt {
                    img {
                        width: 64px;
                        height: 64px;
                    }
                }
                dd {
                    margin-top: 17px;
                    color: #fefefe;
                    font-size: 12px;
                }
            }
            .tel {
                flex: 4;
                display: flex;
                justify-content: center;
                flex-direction: column;
                font-size: 16px;
                text-align: center;
                .contract {
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #cbcbcb;
                    img {
                        margin-right: 7px;
                        width: 26px;
                        height: 16px;
                    }
                }
                .workTime {
                    color: #cbcbcb;
                    font-size: 16px;
                    margin-top: 23px;
                    margin-bottom: 25px;
                }
                p {
                    font-size: 17px;
                    color: #fefefe;
                }
            }
        }
    }
    .friendLink{
        padding-top:35px;
        .link-tab{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 10px;
            li{
                color: #5c6a8e;
                font-size: 12px;
                font-weight: bold;
                margin: 0 20px;
                cursor: pointer;
            }
            .active{
                color: #939EB9;
            }
        }
        .link-content{
            .friendship {
                display: none;
                justify-content: center;
                align-items: center;
                padding-bottom: 5px;
                color: #939EB9;
                font-weight: 400;
                font-size: 12px;
                p {
                    margin-bottom: 10px;
                    display: flex;
                    align-items: center;
                    a {
                        display: block;
                        color: #939EB9;
                        padding: 0 5px;
                        font-weight: 400;
                        font-size: 12px;
                        text-align: center;
                        &:hover {
                            color: #fff;
                        }
                    }
                    &::after{
                        content: '|';
                    }
                }
                p:last-child{ 
                    &::after{
                        content: '';
                    }
                }
            }
            .active{
                display: flex;
                flex-wrap: wrap;
            }
        }
    }
    .copyright {
        color: #999eaa;
        font-size: 12px;
        text-align: center;
        a{
            color:#999EAA;
        }
    }
}
</style>
